import React, { useEffect, useMemo } from 'react'
import Select from 'react-select'
import { useMasterData } from '../../utils/useMasterData'

function AddExpenseRegister({ sendDataToParent, onLoad }) {
  const { items: expenseCategoryItems, loading: expenseCategoryLoading } = useMasterData('expenseCategory')
  const defaultExpenseDate = useMemo(() => new Date().toISOString().split('T')[0], [])

  const expenseCategoryOptions = useMemo(() => {
    return (expenseCategoryItems || []).map((item) => ({
      value: item.MasterValueId.toString(),
      label: item.DisplayName || item.ValueName || '',
      id: item.MasterValueId
    }))
  }, [expenseCategoryItems])

  function handleChange(e) {
    const { name, value } = e.currentTarget
    sendDataToParent((prevState) => ({
      ...(prevState ?? {}),
      [name]: value,
    }))
  }

  const handleCategoryChange = (option) => {
    sendDataToParent((prevState) => ({
      ...(prevState ?? {}),
      ExpenseCategoryId: option ? option.value : '',
      ExpenseCategoryName: option ? option.label : ''
    }))
  }

  useEffect(() => {
    onLoad?.(undefined)
    sendDataToParent((prevState) => ({
      ...(prevState ?? {}),
      ExpenseDate: defaultExpenseDate
    }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <div className="row">
        <div className="col-lg-6 mb-3">
          <label className="form-label">Expense Category <span style={{ color: 'red' }}>*</span></label>
          <Select
            classNamePrefix="react-select"
            options={expenseCategoryOptions}
            isLoading={expenseCategoryLoading}
            isClearable
            placeholder="Select expense category"
            onChange={handleCategoryChange}
          />
        </div>
        <div className="col-lg-6 mb-3">
          <label className="form-label">Expense Date <span style={{ color: 'red' }}>*</span></label>
          <input
            type="date"
            className="form-control"
            name="ExpenseDate"
            defaultValue={defaultExpenseDate}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-6 mb-3">
          <label className="form-label">Amount <span style={{ color: 'red' }}>*</span></label>
          <input
            type="number"
            className="form-control"
            name="Amount"
            step="0.01"
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-6 mb-3">
          <label className="form-label">Reference</label>
          <input
            type="text"
            className="form-control"
            name="ReferenceNo"
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-12 mb-3">
          <label className="form-label">Expense For</label>
          <input
            type="text"
            className="form-control"
            name="ExpenseFor"
            onChange={handleChange}
          />
          <small className="text-muted">Free text (e.g., employee, department, vendor)</small>
        </div>
        <div className="col-lg-12 mb-3">
          <label className="form-label">Description</label>
          <textarea
            className="form-control"
            rows={4}
            maxLength={600}
            name="Description"
            onChange={handleChange}
          />
          <small className="text-muted">Maximum 600 characters</small>
        </div>
      </div>
    </>
  )
}

export default AddExpenseRegister
